import * as yup from "yup";

export const SignupValidation = yup.object().shape({
  firstName: yup.string().required("Please enter first name."),
  lastName: yup.string().required("Please enter last name."),
  email: yup
    .string()
    .required("Please enter email.")
    .email("Please enter valid email."),
  password: yup
    .string()
    .required("Please enter password.")
    .min(6, "Please enter at least 6 digit password.")
    .max(20, "Password should not be more than 20 characters."),
  confirmPassword: yup
    .string()
    .oneOf(
      [yup.ref("password")],
      "Password and confirm password didn't match."
    ),
});
